import { Pipe, PipeTransform } from '@angular/core';

import { HotelAmenity } from '@hotels/hotel-detail/entities/hotel-detail.response';
import { HotelRoomAmenities } from '@hotels/hotel-results/entities/hotel-searched';


const AMENITIES_WITH_ICON = [
  1, 2, 5, 5, 7, 12, 14, 15, 16, 20, 20, 21, 21,
  22, 24, 26, 33, 33, 35, 35, 42, 46, 48, 49, 50,
  51, 54, 55, 61, 65, 66, 68, 69, 71, 72, 72, 74,
  76, 77, 78, 79, 84, 92, 96, 97, 100, 101, 102,
  106, 107, 122, 123, 132, 149, 165, 169, 175, 176,
  179, 192, 193, 195, 198, 202, 205, 218, 223, 224,
  229, 234, 236, 239, 240, 241, 241, 253, 259, 261,
  261, 262, 263, 268, 269, 271, 274, 282, 10000, 10001
];

@Pipe({
  name: 'amenitiesRoomVm',
  standalone: false
})
export class AmenitiesRoomVmPipe implements PipeTransform {

  private hotelAmenities: HotelAmenity[] = [];

  transform(hotelRoomAmenities: HotelRoomAmenities[],
    amountAmenities: number,
    showAll?: boolean): HotelAmenity[] | null {

    if (!hotelRoomAmenities) {
      return null;
    }

    this.initAmenitiesWithIcon(hotelRoomAmenities);
    return this.sortAmenities(amountAmenities, showAll);
  }

  private initAmenitiesWithIcon(hotelRoomAmenities: HotelRoomAmenities[]): void {

    this.hotelAmenities = [];

    hotelRoomAmenities.forEach(amenity => {
      const findAmenity = AMENITIES_WITH_ICON.find(amenityIcon => amenityIcon === +amenity.HAC);
      this.addAmenity(amenity, findAmenity ? `${amenity.HAC}.svg` : undefined);
    });
  }

  private addAmenity(amenities: HotelRoomAmenities, icon: string): void {
    this.hotelAmenities.push(
      {
        Name: Array.isArray(amenities.Description) ? amenities.Description[0].Description : amenities.Description,
        Code: amenities.RoomAmenityId?.toString(),
        Icon: icon ? icon : null,
        Highlight: amenities.Highlight ? amenities.Highlight : false
      }
    );
  }

  private sortAmenities(amountAmenites: number, showAll: boolean = false): HotelAmenity[] {

    const orderByIcon = (a: HotelAmenity, b: HotelAmenity): 1 | -1 | 0 => a.Icon === b.Icon ? 0 : a.Icon ? -1 : 1;

    /**
     * Order highlighted amenities with icon first, then those no highlighted amenities with icon.
     * By last highlighted amenities without icon and no highlighted amenities without icon
     */
    const orderByHighlight = (hotelAmenities: HotelAmenity[]) => {
      const amenitiesHighlighted = hotelAmenities.filter(amenity => amenity.Highlight).sort(orderByIcon);
      const amenitiesLowlighted = hotelAmenities.filter(amenity => !amenity.Highlight).sort(orderByIcon);

      return [].concat(
        amenitiesHighlighted.filter(amenity => amenity.Icon),
        amenitiesLowlighted.filter(amenity => amenity.Icon),
        amenitiesHighlighted.filter(amenity => !amenity.Icon),
        amenitiesLowlighted.filter(amenity => !amenity.Icon));
    };

    const hotelAmenitiesSorted = this.hotelAmenities.length > 0 && showAll ?
      orderByHighlight(this.hotelAmenities) :
      orderByHighlight(this.hotelAmenities).slice(0, amountAmenites);

    return hotelAmenitiesSorted;
  }
}
